import { MyrAPIService } from '../../../../api/myr/myrAPI';
import { IRewardsBalanceResponse, ITermDetail } from '../../rewardsClub.interface';
import { MyrAPIEndpoints } from '../../../../api/myr/myrAPIEndpoints.constant';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export async function memberGetAllRewardsBalances(
    cashback: boolean,
): Promise<IRewardsBalanceResponse[]> {
    const response: IRewardsBalanceResponse[] = await MyrAPIService.sendRequest<
        IRewardsBalanceResponse[]
    >(`${MyrAPIEndpoints.POINTS}/balance?points=true&cashback=${cashback.toString()}`, 'GET');

    return response.map((item) => {
        return {
            ...item,
            termDetails: setDaysBeforeExpiry(formatDate(item.termDetails.sort(dateSorter))),
        };
    });
}

export async function getMemberRewardBalanceByCurrency(
    pointCurrency: string,
    cashbackCurrency?: string | null,
): Promise<IRewardsBalanceResponse[]> {
    let memberPointsEndpoint = `member/points/balance/currency?points=${pointCurrency}`;

    if (cashbackCurrency !== undefined && cashbackCurrency !== null) {
        memberPointsEndpoint = `member/points/balance/currency?points=${pointCurrency}&cashback=${cashbackCurrency}`;
    }

    const response: IRewardsBalanceResponse =
        await MyrAPIService.sendRequest<IRewardsBalanceResponse>(memberPointsEndpoint, 'GET');

    const responseWithAdditionalInfo = {
        ...response,
        termDetails: setDaysBeforeExpiry(formatDate(response.termDetails.sort(dateSorter))),
    };

    return [responseWithAdditionalInfo];
}

const dateSorter = (a: ITermDetail, b: ITermDetail) =>
    new Date(a.expiryTime).getTime() - new Date(b.expiryTime).getTime();

function formatDate(termDetails: ITermDetail[]) {
    return termDetails.map((entry) => ({
        ...entry,
        formattedExpiryTime: new Date(entry.expiryTime).toLocaleDateString(),
    }));
}

function setDaysBeforeExpiry(termDetails: ITermDetail[]) {
    const today = new Date();
    return termDetails.map((entry) => ({
        ...entry,
        expiresInDays: Math.floor(
            (new Date(entry.expiryTime).getTime() - today.getTime()) / _MS_PER_DAY,
        ),
    }));
}
